<template>
    <fragment>
        <div v-if="annotationsWithSameSubjectInConvenion.length > 0">
            <div
                class="insurer-container"
                v-for="insurer in annotationsWithSameSubjectInConvenion"
                :key="insurer._uid"
            >
                <insurer-code-and-type
                    :insurer="insurer"
                    :insurers="insurers"
                    :annotationOptions="annotationOptions"
                />
                <insurer-guarantees
                    :insurer="insurer"
                    :annotationOptions="annotationOptions"
                    :tags="insurer.tags"
                />
                <csp-list
                    :cspCodes="insurer.cspCodes"
                    :conventionCspConfig="convention.cspConfig"
                />
            </div>
        </div>
        <div class="empty-insurer-container" v-else>
            Absence de dispositions conventionnelles
        </div>
    </fragment>
</template>

<script>
import { Fragment } from "vue-fragment";
import InsurerCodeAndType from "./InsurerCodeAndType.vue";
import CspList from "../../../common/CspList.vue";
import InsurerGuarantees from "./InsurerGuarantees.vue";

export default {
    components: { Fragment, InsurerCodeAndType, CspList, InsurerGuarantees },
    props: ["subject", "convention", "insurers", "annotationOptions"],
    computed: {
        annotationsWithSameSubjectInConvenion() {
            if (!this.convention.annotationsArray) return [];
            return this.convention.annotationsArray.filter(
                annotation =>
                    annotation["subject"] === this.subject.code &&
                    annotation["type"] === this.subject.type
            );
        },
    },
};
</script>

<style scoped lang="sass">
.insurer-container
    display: flex
    align-items: center
    padding: 10px 0
    &:not(:last-child)
        border-bottom: 1px solid $color-grey
.empty-insurer-container
    display: flex
    justify-content: center
    color: $color-grey
</style>
